import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('authToken'));
  const [loading, setLoading] = useState(true); // Manage loading state

  // Placeholder login function - replace with actual API call
  async function login(email, password) {
    console.log("Attempting login with:", email); 
    // Simulate API call
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Simulate success - in reality, you'd get user data and a token
        const fakeUser = { email: email, name: "Warehouse User" }; 
        const fakeToken = "fake-jwt-token"; 
        
        localStorage.setItem('authToken', fakeToken);
        setToken(fakeToken);
        setCurrentUser(fakeUser);
        resolve(fakeUser); 
        // Simulate failure:
        // reject(new Error("Invalid Credentials"));
      }, 500); 
    });
  }

  // Placeholder logout function
  function logout() {
    console.log("Logging out");
    localStorage.removeItem('authToken');
    setToken(null);
    setCurrentUser(null);
  }

  // Effect to check for existing token on initial load
  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    if (storedToken) {
      // Here you might want to verify the token with your backend
      // and fetch user data if the token is valid.
      // For this basic example, we'll just assume the token is valid
      // and create a dummy user if a token exists.
      setToken(storedToken);
      // You might fetch user details based on the token here
      // setCurrentUser({ name: "Restored User" }); 
      console.log("Found existing token on load.");
    }
    setLoading(false); // Finished initial auth check
  }, []);

  const value = {
    currentUser,
    token,
    login,
    logout,
  };

  // Don't render children until the initial auth check is complete
  return (
    <AuthContext.Provider value={value}>
      {!loading && children} 
    </AuthContext.Provider>
  );
} 